import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  accordion: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    margin: '0px',
    marginBottom: '16px',
    '& .MuiAccordionSummary-root': {
      minHeight: '36px',
      margin: '0px',
      padding: '8px 16px',
      backgroundColor: capitalDesignTokens.foundations.colors.gray50,
      fontWeight: capitalDesignTokens.foundations.typography.fontWeight.semiBold,
      '&.Mui-expanded': {
        backgroundColor: capitalDesignTokens.foundations.colors.cerulean100
      },
      '& .MuiAccordionSummary-content': {
        margin: '0px'
      }
    }
  },
  expandIcon: {
    fontSize: 'small'
  },
  accordionDetails: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%'
  }
});
